import isDuitangImage from './isDuitangImage';
import { _dtImageTrans } from './__inner/image/_dtImageTrans';
import { _transToWebp } from './__inner/image/_transToWebp';

/**
 * @description 缩放成指定宽度、高度自适应的图片。可配置是否将gif动图转成静态图、是否转成webp格式。
 * @param url 图片地址
 * @param width 期望宽度
 * @param gifTrans 是否将gif转成静态图，默认是
 * @param webpTrans 若浏览器支持，是否将转成webp格式，默认是
 * @returns 被裁剪后的图片地址
 */
const dtThumb = (url: string, width: number, gifTrans = true, webpTrans = true): string => {
  let ret = _dtImageTrans(url, true, width, false);

  if (isDuitangImage(ret)) {
    if (gifTrans) {
      ret = ret.replace(/\.gif$/, '.gif_jpeg');
    }
    if (webpTrans) {
      ret = _transToWebp(ret);
    }
  }
  return ret;
};

export default dtThumb;
